import { dndPromotion, getAwardSrcById } from "../../setup/js/_promotion";

$(document).on(
  "revelation__s27_vongquay rendered",
  {},
  function (event, uniqueId) {
    var $this = $("#" + uniqueId);

    // console.log(event);
    // console.log(uniqueId);
    // console.log($this);
    if ($(".action").length > 0) {
      dndPromotion({
        url: domain,
        debug: false,
        wait: 0,
        items: {
          A: "1",
          B: "2",
          C: "3",
          D: "4",
          E: "5",
          F: "6",
          G: "7",
          H: "8",
          I: "9",
          K: "10",
          length: 10,
          type: "png",
        },
        names: [
          "Vé Chân Mây",
          "Mảnh đá thần cách x200",
          "Thú Cưỡi Gà Cục Tác",
          "Tinh Phách Nguyệt Minh",
          "Set thời trang lộc minh sâm",
          "Vé Dệt Mộng x8",
          "Hộp chọn đá vàng cam",
          "Tinh Hoa thần cách tự chọn - cang x6",
          "Cá chép thành đôi x30",
          "Vé Dệt Mộng x30",
        ],
        callback: function () {},
        animBefore: function () {
          $("#action").addClass("off");
        },
        animResult: function (listPrize) {
          if (typeof LuckyDrawExchangeModule !== "undefined") {
            LuckyDrawExchangeModule.fetchViewData();
          }

          var displayPrize = listPrize[0];

          setTimeout(function () {
            $("#effect").removeClass("animating");
            var prizeIndex = displayPrize.indexImg;
            var order = -1;
            var rounds = 2;
            (function linearLoop(i) {
              setTimeout(function () {
                $("#effect .effect__item").removeClass("active");
                order++;

                if ($("#effect .effect__item").eq(order).length === 0) {
                  order = 0;
                }

                $("#effect .effect__item").eq(order).addClass("active");

                if (order == prizeIndex - 1) rounds--;
                if (rounds) linearLoop(i);
                else {
                  setTimeout(function () {
                    $("#effect .effect__item").removeClass("active");
                    $("#action").removeClass("off");
                    $("#popup_reward").addClass("active");
                  }, 500);
                }
              }, 200);
            })(99);
          }, 0);
        },
        animWait: function () {
          $("#action").addClass("off");
          $("#effect").removeClass("animating");
        },
      });

      window["getAwardSrcById"] = getAwardSrcById;
    }
  }
);
